import { createTheme } from '@mui/material/styles';
import { BaseMuiThemeComponentsSettings } from './toolympus/components/primitives/BaseThemeSettings';

export const ThemeSettings = {
  colors: {
    primary: "#c7dc41",
    primaryL1: "#c7dc41", 
    secondary: "#bad1ec",
    background: "#fdfdff",
    text: "#10100e",
    textSecondary: "#10100ea0",
    black: "#10100e"
  },
}


export const theme = createTheme({
    palette: {
        primary: {
            main: ThemeSettings.colors.primary,
        },
        secondary: {
            main: ThemeSettings.colors.secondary,
        },
        text: {
          primary: ThemeSettings.colors.text,
          secondary: ThemeSettings.colors.textSecondary,
        },
    },

    components: {
      ...BaseMuiThemeComponentsSettings,
    },
});
